import api from "api";
import BlockHeader from "component/BlockHeader/BlockHeader";
import PaginationWrapper from "component/Pagination";
import {InitiativeList} from "component/InitiativeList";
import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import { createBrowserHistory, parsePath } from "history";
import { useLocation, useNavigate, useSearchParams, createSearchParams } from "react-router-dom";
import stateMap from "store/stateMap";
import update from 'immutability-helper';
import {ReactComponent as SVGArrowUp} from '../../../../../assets/arrow-up.svg';
import "./../../../Browse/style.scss";
import Sidebar from "component/Sidebar";
import _ from "lodash";
import Header from "component/Header/Header";
import Footer from "component/Footer/Footer";
import Breadcrumb from "component/Breadcrumb";
import { PageCredential } from "component/PageCredential";

export default connect(stateMap)((props) => {

    const [eventTypes, setEventTypes] = useState(false);
    const binusCampus = props.config.campus;
    useEffect(()=>{

        api('/EventType', 'get', {
            posts_per_page : -1
        })
            .then((response) => {


                setEventTypes(response.types);

            })
    }, []);


    let location                                = useLocation();
    let history                                 = createBrowserHistory();
    
    const [initiatives, setInitiatives]         = useState(false);
    const [countInitiative, setCountInitiative] = useState(false);
    const [dataLoading, setDataLoading]         = useState(false) ;
    const queryString                           = new URLSearchParams(parsePath(window.location.href).search || '');
    const [parameter, setParameter]             = useState({
        paged           : parseInt(queryString.get('page') || 1)  
        ,posts_per_page : parseInt(queryString.get('posts_per_page')) || 9
        ,scope_level : queryString.get('scope_level') || ''
        ,event_forms : queryString.get('event_forms') || ''
        ,campus_area : queryString.get('campus_area') || ''
        ,event_type_id : queryString.get('event_type_id') || ''
        ,event_look_for : queryString.get('event_look_for') || 'crew'
    });


    const changeParams = (e) => {
        e.preventDefault();

        if(dataLoading)
        {
            return;
        }

        let [toUpdateFilter, updatedValue] = e.currentTarget.name.split(':');

        setParameter(
            update(parameter, { $apply : function(params){

                if(params[toUpdateFilter] == updatedValue)
                {
                    params[toUpdateFilter] = '';
                }
                else
                {
                    params[toUpdateFilter] = updatedValue;
                }
    
                params.paged = 1;
    
                return _.assign({}, params);
    
            }})
        );
    }

    const loadInitiative = () => {

        if(dataLoading)
        {
            return;
        }

        let processedParameter = update(parameter, {
            $apply : prm => {
                if(prm.event_type_id)
                {
                    prm.event_type_id = [prm.event_type_id];
                }
                else
                {
                    prm = _.omit(prm, 'event_type_id');
                }
                return prm;
            }
        })

        var DataToLoad = [
            api('/Initiative', 'get', _.assign({event_metadata : 1, type : 'event'}, processedParameter))
        ];

        if(processedParameter.paged === 1)
        {
            DataToLoad.push(
                api('/Initiative', 'get', _.assign({event_metadata : 1, get_total : 1, type : 'event'}, processedParameter))
            );
        }

        setDataLoading(true);

        Promise.all(DataToLoad)
            .then((response) => {
                setDataLoading(false);

                setInitiatives(response[0].initiative);

                history.replace(
                    { search: `?${createSearchParams(parameter)}`}
                );

                if(processedParameter.paged === 1)
                {
                    setCountInitiative( parseInt(response[1].initiative) );
                }

            })
            .catch((error) => {
                setDataLoading(false);
                
            })
    }
    
    useEffect(loadInitiative, [props.auth.user, parameter]);

    return(
        <>
            <Header/>
            <PageCredential title={"Archive of Event Initiatives "}/>
            <div id="initiative-archives" className="container relative">
                
                <Sidebar>
                    <div className="initiatives-filters filters-boxes">
                        <div className="filters-boxes mb-md">
                            <div className="filter-box">
                                <div className="wrapper">
                                    <span className="filter-title">
                                        Required Crowd
                                    </span>
                                    <div className="filter-body">
                                        <ul className="filter-items">
                                            <li 
                                                className={`leading-text filter-item ${'crew' == parameter.event_look_for && 'active'}`}>
                                                    <a 
                                                        href="#" 
                                                        name={`event_look_for:crew`} 
                                                        onClick={changeParams} 
                                                        dangerouslySetInnerHTML={{__html : 'Event Crew' }}/>
                                            </li>
                                            <li 
                                                className={`leading-text filter-item ${'participant' == parameter.event_look_for && 'active'}`}>
                                                    <a 
                                                        href="#" 
                                                        name={`event_look_for:participant`} 
                                                        onClick={changeParams} 
                                                        dangerouslySetInnerHTML={{__html : 'Event Registration' }}/>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="filters-boxes mb-md">
                            <div className="filter-box">
                                <div className="wrapper">
                                    <span className="filter-title">
                                        Audience
                                    </span>
                                    <div className="filter-body">
                                        <ul className="filter-items">
                                            <li 
                                                className={`leading-text filter-item ${'internasional' == parameter.scope_level && 'active'}`}>
                                                    <a 
                                                        href="#" 
                                                        name={`scope_level:internasional`} 
                                                        onClick={changeParams} 
                                                        dangerouslySetInnerHTML={{__html : 'International' }}/>
                                            </li>
                                            <li 
                                                className={`leading-text filter-item ${'nasional' == parameter.scope_level && 'active'}`}>
                                                    <a 
                                                        href="#" 
                                                        name={`scope_level:nasional`} 
                                                        onClick={changeParams} 
                                                        dangerouslySetInnerHTML={{__html : 'National' }}/>
                                            </li>
                                            <li 
                                                className={`leading-text filter-item ${'regional' == parameter.scope_level && 'active'}`}>
                                                    <a 
                                                        href="#" 
                                                        name={`scope_level:regional`} 
                                                        onClick={changeParams} 
                                                        dangerouslySetInnerHTML={{__html : 'Regional' }}/>
                                            </li>
                                            <li 
                                                className={`leading-text filter-item ${'provinsi' == parameter.scope_level && 'active'}`}>
                                                    <a 
                                                        href="#" 
                                                        name={`scope_level:provinsi`} 
                                                        onClick={changeParams} 
                                                        dangerouslySetInnerHTML={{__html : 'Local' }}/>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="filters-boxes mb-md">
                            <div className="filter-box">
                                <div className="wrapper">
                                    <span className="filter-title">
                                        Event Type
                                    </span>
                                    <div className="filter-body">
                                        <ul className="filter-items">
                                            {
                                                eventTypes !== false && eventTypes.map(eventType => (
                                                    <li 
                                                        key={eventType.EventTypeID}
                                                        className={`leading-text filter-item ${eventType.EventTypeID == parameter.event_type_id && 'active'}`}>
                                                            <a 
                                                                href="#" 
                                                                name={`event_type_id:${eventType.EventTypeID}`} 
                                                                onClick={changeParams} 
                                                                dangerouslySetInnerHTML={{__html : eventType.TypeName }}/>
                                                    </li>
                                                ))
                                            }
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="filters-boxes mb-md">
                            <div className="filter-box">
                                <div className="wrapper">
                                    <span className="filter-title">
                                        Location
                                    </span>
                                    <div className="filter-body">
                                        <ul className="filter-items">
                                            <li 
                                                className={`leading-text filter-item ${'onsite' == parameter.event_forms && 'active'}`}>
                                                    <a 
                                                        href="#" 
                                                        name={`event_forms:onsite`} 
                                                        onClick={changeParams} 
                                                        dangerouslySetInnerHTML={{__html : 'Onsite' }}/>
                                            </li>
                                            <li 
                                                className={`leading-text filter-item ${'online' == parameter.event_forms && 'active'}`}>
                                                    <a 
                                                        href="#" 
                                                        name={`event_forms:online`} 
                                                        onClick={changeParams} 
                                                        dangerouslySetInnerHTML={{__html : 'Online' }}/>
                                            </li>
                                            <li 
                                                className={`leading-text filter-item ${'hybrid' == parameter.event_forms && 'active'}`}>
                                                    <a 
                                                        href="#" 
                                                        name={`event_forms:hybrid`} 
                                                        onClick={changeParams} 
                                                        dangerouslySetInnerHTML={{__html : 'Hybrid' }}/>
                                            </li>

                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="filters-boxes mb-md">
                            <div className="filter-box">
                                <div className="wrapper">
                                    <span className="filter-title">
                                        BINUS Campus
                                    </span>
                                    <div className="filter-body">
                                        <ul className="filter-items">
                                            {
                                                binusCampus.map(campus => (
                                                    <li 
                                                    key={campus[0]}
                                                        className={`leading-text filter-item ${campus[0] == parameter.campus_area && 'active'}`}>
                                                            <a 
                                                                href="#" 
                                                                name={`campus_area:${campus[0]}`} 
                                                                onClick={changeParams} 
                                                                dangerouslySetInnerHTML={{__html : campus[1] }}/>
                                                    </li>
                                                ))
                                            }
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>                        
                    </div>
                </Sidebar>
                <div className="initiative-list-container">
                    <Breadcrumb
                        items={[
                            ['/', 'Crowdbees']
                            ,['/event/', 'Event']
                            ,['Browse']
                        ]}
                    />
                    <div className="initiatives-list">
                        {
                            initiatives === false ? <span className="skeleton"></span>:
                            (
                                <Fragment>
                                    {
                                        dataLoading ? <div><span className="skeleton"></span></div> :
                                        <>
                                            { 
                                                <BlockHeader title="Event" desc={"About "+ countInitiative +" initiatives"}/>
                                            }
                                            <InitiativeList initiatives={initiatives}/>
                                            <PaginationWrapper
                                                className="mt-4"
                                                activePage={parameter.paged}
                                                itemsCountPerPage={parameter.posts_per_page}
                                                totalItemsCount={countInitiative}
                                                pageRangeDisplayed={5}
                                                onChange={(pagenumber) => {
                                                    setParameter(update(parameter, { paged : {$set : pagenumber } }))
                                                }}
                                            />
                                        </>
                                    }
                                </Fragment>
                            )
                        }
                    </div>
                </div>
            </div>
            <Footer/>
        </>
    )
});